import './instrument';

import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import SentryFallback from './pages/error/sentry-fallback';

import App from './app/app';
import './theme/tailwind.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={SentryFallback}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>
);
